export { default as CoreFormConsumer } from './Consumer';
